module.exports = __webpack_public_path__ + "img/30m1.aee24902.jpg";